import { sniff } from '@/util'

// 显示拍卖小锤子
const showSatelliteMenu = function () {
  if (sniff.isUboxAndroidApp) {
    window.app?.showSatelliteMenu && window.app?.showSatelliteMenu()
  } else if (sniff.isUboxIosApp) {
    window?.webkit?.messageHandlers?.showSatelliteMenu && window?.webkit?.messageHandlers?.showSatelliteMenu.postMessage('')
  }
}

export default showSatelliteMenu